jQuery($ => {
    class FeaturedProductThumbnailCardsCarousel {
        constructor(element) {
            this._                 = element;
            this._element          = $(element);
            this._slider           = this._element.find('.m-product-thumbnail-cards--carousel .m-product-thumbnail-cards__list');
            this._arrowsNavigation = this._element.find('.o-featured-product-thumbnail-cards-carousel__arrows-navigation');

            this.init();
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Initialize
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        init() {
            this.setupHandlers();
            this.checkWindowWidth(); // Add this line to check window width on initialization
            this._element.trigger('init', this);
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Handlers
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
 
        setupHandlers() {
            // Add a handler for window resize
            $(window).on('resize', () => {
                this.checkWindowWidth();
            });
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Check Window Width
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        checkWindowWidth() {
            const windowWidth = $(window).width();

            // If window width is smaller than 500px and slick has been initialized, uninitialize it
            if (windowWidth < 600 && this._slider.hasClass('slick-initialized')) {
                this._slider.slick('unslick');
            }
            // If window width is bigger than 500px and slick hasn't been initialized, initialize it
            else if (windowWidth >= 600 && !this._slider.hasClass('slick-initialized')) {
                this.setupSlick();
            }
        }


        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Slick
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        setupSlick() { 
            this._slider.slick({
                speed: 600,
                slidesToShow: 3,
                swipeToScroll: false,
                variableWidth: true,
                appendArrows: this._element.find('.o-featured-product-thumbnail-cards-carousel__arrows-navigation'),
            });

            this._element.trigger('setup-slick', this);
        }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.featured_product_thumbnail_cards_carousel = function() {
        var _ = this,
                opt = arguments[0],
                args = Array.prototype.slice.call(arguments, 1),
                l = _.length,
                i,
                ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].featured_product_thumbnail_cards_carousel = new FeaturedProductThumbnailCardsCarousel(_[i], opt);
            else
                ret = _[i].featured_product_thumbnail_cards_carousel[opt].apply(_[i].featured_product_thumbnail_cards_carousel, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.o-featured-product-thumbnail-cards-carousel').featured_product_thumbnail_cards_carousel();
});